/**
 * Generated by orval v6.10.1 🍺
 * Do not edit manually.
 * Platform API
 * The Platform API
 * OpenAPI spec version: 2.0
 */

/**
 * Account type
 */
export type GetCardTransactionDetailsResponseDataItemAccountType = typeof GetCardTransactionDetailsResponseDataItemAccountType[keyof typeof GetCardTransactionDetailsResponseDataItemAccountType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetCardTransactionDetailsResponseDataItemAccountType = {
  CREDIT: 'CREDIT',
  DEBIT: 'DEBIT',
} as const;
